<script>
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";
import SearchDataWasteCategoryModal from '@/components/InputSearchModal/SearchDataWasteCategoryModal.vue'
import SearchDataVendorSiteModal from "@/components/InputSearchModal/SearchDataVendorSiteModal";
import SearchDataWorkOrderModal from "@/components/InputSearchModal/SearchDataWorkOrderModal.vue";
import router from "@/mixins/router";

export default {
  components: {
    SearchDataWorkOrderModal,
    SearchDataVendorSiteModal,
    CommonTableComponent,
    SearchDataWasteCategoryModal
  },
  mixins: [tableSearch, router],
  props: ['work_reservation', 'dailyReport'],
  data() {
    return {
      isLoading: false,
      header: this.$constant.tableHeaders.work_reservation.wastes_or_services,
      dataSelected: {
        workOrderId: null,
        wasteOrServices: [],
        carTypes: [],
      },
      numberOfCars: {},
      workOrderSelected: {},
      listWorkOrder: [],
      filters: {
        zz_work_order_type_id: [],
        waste_category_of_treatment_name_abbreviated: "",
        vendor_site_name_abbreviated: "",
        name: "",
      },
      btnBackText: this.$lang.button.back,
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const url = apiEndpoints.select_waste_or_service(this.caseId);
      const {status, data} = await this.$http.get(url, this.filters);

      if (status && data.result) {
        this.listWorkOrder = data.result;
      }
      this.isLoading = false;
    },
    search() {
      this.getData();
    },
    updateValue: function () {
      let workOrder = this.listWorkOrder.find(workOrder => workOrder.id === this.dataSelected.workOrderId)
      let wasteOrServices = workOrder.wasteOrServices.filter(item =>
        this.dataSelected.wasteOrServices.includes(item.wastes_or_services_by_work_order_id))
      let carTypes = workOrder.car_types.filter(item => this.dataSelected.carTypes.includes(item.id));
      carTypes.forEach(item => {
        // 台数はテキストボックスの入力値を設定
        item.number_of_cars = this.numberOfCars[item.id];
      });
      this.$emit("dataSelected", {workOrderId: workOrder.id, wasteOrServices, carTypes, workOrderType: workOrder.zz_work_order_type?.id});
      this.$bvModal.hide("select-car-type");
      this.$bvModal.hide('select-waste-or-service')
    },
    handleCheckBoxDisable(workOrderId) {
      return this.dataSelected.wasteOrServices.length > 0 && this.dataSelected.workOrderId !== workOrderId
    },
    handleSelectWasteOrServices(workOrderId) {
      if (this.dataSelected.workOrderId !== workOrderId) {
        this.dataSelected.workOrderId = workOrderId
        this.dataSelected.carTypes = []

        // numberOfCars に 選択した作業指示に紐づいた car_types_by_work_order_id と number_of_cars (テキストボックスの初期値となる) をペアで保持
        this.numberOfCars = {};
        let workOrder = this.listWorkOrder.find(workOrder => workOrder.id === this.dataSelected.workOrderId);
        workOrder.car_types.forEach(item => {
          this.numberOfCars[item.id] = item.number_of_cars;
        });
      }
    },
    saveSelectWasteOrServices() {
      if (this.dailyReport) {
        this.updateValue()
      } else {
        this.$bvModal.show("select-car-type");
      }
    },
    onSelectData(data) {
      this.filters = data;
    },
    onSelectDataWorkOrder(data) {
      this.filters = {
        ...data,
        name: data.work_order_name,
      };
    },
    clearDataSearch() {
      this.filters = {
        zz_work_order_type_id: [],
        waste_category_of_treatment_name_abbreviated: "",
        vendor_site_name_abbreviated: "",
        name: "",
      }
      this.search()
    },
    hideSelectWasteOrServiceModal() {
      this.$bvModal.hide('select-waste-or-service')
    },
    onClickRow(row, workOrder) {
      if (!!this.dataSelected.workOrderId && workOrder.id !== this.dataSelected.workOrderId) {
        return;
      }
      if (!this.dataSelected.wasteOrServices.includes(row.wastes_or_services_by_work_order_id)) {
        this.dataSelected.wasteOrServices.push(row.wastes_or_services_by_work_order_id)
      } else {
        const index = this.dataSelected.wasteOrServices.indexOf(row.wastes_or_services_by_work_order_id)
        if (index > -1) {
          this.dataSelected.wasteOrServices.splice(index, 1)
        }
      }
      this.handleSelectWasteOrServices(workOrder.id)
    },
    openModalWorkOrder() {
      this.$refs.searchDataWorkOrderModal.openModal()
    },
    updateNumberOfCars(id, number) {
      // テキストボックスの更新時に反映
      this.numberOfCars[id] = parseInt(number);
    },
  },
  computed: {
    caseId() {
      if (this.dailyReport) {
        return  this.dailyReport.case_id
      }
      return this.$route.params.case_id
    },
    zzWorkOrderTypes() {
      return this.$store.getters['options/options_tables'].zz_work_order_types ?? [];
    },
    estimates() {
      return this.listWorkOrder.length ? this.listWorkOrder.find(item => item.id === this.dataSelected.workOrderId)?.car_types : []
    },
  },
  watch: {
    'work_reservation': function (newValue) {
      this.dataSelected = {
        workOrderId: newValue.work_order_id,
        wasteOrServices: newValue.wastes_or_services_by_work_reservation?.map(item => item?.wastes_or_services_by_work_order_id) ?? [],
        carTypes: newValue.car_estimates_by_work_reservation?.map(item => item.id) ?? [],
      }

      // this.numberOfCarsを組み立てる
      //arr[id]=number_of_carsの形
      var tmp = {};
      newValue.car_estimates_by_work_reservation.forEach(function(item){
        tmp[item.id] = item.number_of_cars;
      });
      this.numberOfCars = tmp;
    },
    'dataSelected.wasteOrServices': function (newValue) {
      if (!newValue.length) {
        this.dataSelected.workOrderId = null;
      }
    },
  }
}
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <button
      v-b-modal.select-waste-or-service
      class="btn btn-primary waves-effect waves-light"
      v-if="dailyReport"
    >
      <i class='far fa-list-alt'></i> 廃棄物・サービスを選択する
    </button>
    <button
      v-b-modal.select-waste-or-service
      class="btn btn-primary waves-effect waves-light"
      v-else
    >
      <i class='far fa-list-alt'></i> 廃棄物・サービスを選択する
    </button>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="select-waste-or-service"
      centered
      title-class="font-18"
      title="作業別廃棄物・サービス一覧"
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div class="waste-or-service">
            <b-row>
              <b-col cols="1">作業分類</b-col>
              <b-col cols="10">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group
                    id="checkbox-zz-work-order-type"
                    class="d-flex gap-3"
                    v-model="filters.zz_work_order_type_id"
                    :options="zzWorkOrderTypes"
                    :aria-describedby="ariaDescribedby"
                    name="checkbox-group-zz-work-order-type-item"
                    text-field="work_order_type"
                    value-field="id"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col cols="6">
                <b-row>
                  <b-col align-self="center" cols="2">作業指示名</b-col>
                  <b-col class="d-flex">
                    <div class="w-100 me-2">
                      <b-form-input
                        id="name"
                        v-model="filters.name"
                        v-on:keyup.enter="search"
                      ></b-form-input>
                    </div>
                    <SearchDataWorkOrderModal
                      :case-id="caseId"
                      ref="searchDataWorkOrderModal"
                      :dataSearch="filters"
                      @dataSelected="onSelectDataWorkOrder"
                    >
                      <template v-slot:openBtn>
                        <b-col class="d-flex">
                          <b-button @click="openModalWorkOrder()" variant="outline-info">
                            <i class="bx bx-file-find"/>
                          </b-button>
                        </b-col>
                      </template>
                    </SearchDataWorkOrderModal>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <SearchDataWasteCategoryModal :dataSearch="filters" @dataSelected="onSelectData"/>
              </b-col>
              <b-col offset="1" cols="5">
                <SearchDataVendorSiteModal :dataSearch="filters" @dataSelected="onSelectData"/>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <div class="d-flex justify-content-center align-items-center">
                <b-button size="lg" variant="primary" @click="search" class="me-2">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-search"></i> {{ this.$lang.button.search }}
                  </div>
                </b-button>
                <b-button @click="clearDataSearch" variant="dark" size="lg">
                  <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
                </b-button>
              </div>
            </b-row>
            <div class="my-2">※作業分類を1つ選択し、その中で複数の廃棄物・サービスの依頼が必要であればチェック願います。</div>
            <CommonTableComponent :height-class="`table-wrapper-500 swosm-table`">
              <thead class="table-light">
              <tr class="text-center align-middle">
                <th
                  v-for="(item, index) in header"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span v-html="item.text"> </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <template
                v-for="(workOrder, indexWorkOrder) in listWorkOrder">
                <tr v-for="(wasteOrService, index) in workOrder.wasteOrServices">
                  <td :rowspan="workOrder.wasteOrServices.length" class="text-center" v-if="index===0">
                    {{ workOrder.id }}
                  </td>
                  <td
                    :rowspan="workOrder.wasteOrServices.length"
                    v-if="index===0"
                  >
                    <a @click.exact="
                      redirectRouteTargetBlank(
                        'projects.sales.instructions.detail',
                        {
                          id: caseId,
                          work_order_id: workOrder.id
                        },
                        {readonly: true},
                        ''
                      )
                    "
                    class="cursor-pointer" href="javascript:void(0);">{{ workOrder.name }}</a>
                  </td>
                  <td :rowspan="workOrder.wasteOrServices.length" v-if="index===0">
                      <span v-if="workOrder.zz_work_order_type">
                        {{ workOrder.zz_work_order_type.work_order_type }}
                      </span>
                  </td>
                  <td class="text-center" @click="onClickRow(wasteOrService, workOrder)">
                    <b-form-checkbox
                      v-model="dataSelected.wasteOrServices"
                      :disabled="handleCheckBoxDisable(workOrder.id)"
                      :value="wasteOrService.wastes_or_services_by_work_order_id"
                      @change="handleSelectWasteOrServices(workOrder.id)"
                    ></b-form-checkbox>
                  </td>
                  <td @click="onClickRow(wasteOrService, workOrder)">{{ wasteOrService.name }}</td>
                  <td @click="onClickRow(wasteOrService, workOrder)">{{ wasteOrService.waste_category_of_treatment_name_abbreviated }}</td>
                  <td @click="onClickRow(wasteOrService, workOrder)">{{ wasteOrService.vendor_sites_name_abbreviated }}</td>
                  <td @click="onClickRow(wasteOrService, workOrder)">{{ wasteOrService.treatment_method }}</td>
                </tr>
              </template>
              <tr v-if="!listWorkOrder.length && !isLoading">
                <td :colspan="header.length" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
        </b-overlay>
      </b-row>
      <template #modal-footer>
        <div class="d-flex justify-content-end mt-2">
            <b-button
              size="lg"
              variant="primary"
              class="me-2"
              :disabled="!dataSelected.wasteOrServices.length"
              @click="saveSelectWasteOrServices"
            >
              <i class='fas fa-check'></i> {{ dailyReport ? '選択' : '車両選択へ' }}
            </b-button>
            <b-button
              size="lg"
              variant="primary"
              @click="hideSelectWasteOrServiceModal"
            >
              <i class='far fa-arrow-alt-circle-left'></i> {{ btnBackText }}
            </b-button>
          </div>
      </template>
    </b-modal>
    <b-modal
      size="lg"
      id="select-car-type"
      centered
      title-class="font-18"
      hide-footer
      scrollable
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-end w-100 align-items-center" style="height: 0px;">
          <span style="cursor: pointer;" @click="$bvModal.hide('select-car-type')">×</span>
        </div>
      </template>
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>作業に使用する車両を選択してください。</div>
          <b-row class="d-flex mt-3 mb-4">
            <b-col class="mb-2" cols="6" v-for="(item, index) in estimates">
              <b-form-checkbox
                v-model="dataSelected.carTypes"
                :value="item.id"
              >
                {{ item.invoice_product_name }} ×
                <b-form-input
                  v-model="numberOfCars[item.id]"
                  class="number-of-cars"
                  @input="updateNumberOfCars(item.id, numberOfCars[item.id])"
                  type="number">
                </b-form-input>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-end">
            <b-button
              size="lg"
              variant="primary"
              class="me-2"
              @click="updateValue"
              :disabled="!dataSelected.carTypes.length"
            >
              <i class='fas fa-check'></i> 確定
            </b-button>
            <b-button
              size="lg"
              variant="primary"
              v-b-modal="'select-waste-or-service'"
              @click="$bvModal.hide('select-car-type')"
            >
              <i class='far fa-arrow-alt-circle-left'></i> {{ btnBackText }}
            </b-button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped lang="scss">
.swosm-table {
  max-height: 465px !important;
}
.number-of-cars {
  display: inline;
  width:70px;
  margin-left:5px;
}
</style>
